"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _Checkbox = require("../form/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _Textarea = require("../form/Textarea");

var _Textarea2 = _interopRequireDefault(_Textarea);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectForm = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ProjectForm, _Component);

  function ProjectForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ProjectForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProjectForm.__proto__ || (0, _getPrototypeOf2.default)(ProjectForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (values) {
      var _this$props = _this.props,
          user = _this$props.user,
          company = _this$props.company,
          project = _this$props.project;


      values.user_id = user.id;
      values.company_id = company.id;
      values.business_name = company.name;
      values.business_email = user.email;
      values.project_owner_name = user.first_name + " " + user.last_name;

      if (project) {
        _this.props.updateProject(user.id, project.project_id, values);
      } else {
        _this.props.submitProject(values);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ProjectForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          user = _props.user,
          company = _props.company,
          fields = _props.fields,
          project = _props.project;
      var _props$fields = this.props.fields,
          contractor = _props$fields.contractor,
          contact_person_name = _props$fields.contact_person_name,
          contact_person_phone = _props$fields.contact_person_phone,
          name = _props$fields.name,
          project_description = _props$fields.project_description,
          contact_person_email = _props$fields.contact_person_email,
          construction_site_id = _props$fields.construction_site_id,
          company_id = _props$fields.company_id,
          site_address = _props$fields.site_address,
          postal_code = _props$fields.postal_code,
          postal_area = _props$fields.postal_area,
          active = _props$fields.active;


      if (user) {
        contact_person_name.onChange(user.first_name + " " + user.last_name);
        contact_person_phone.onChange(user.phone);
        contact_person_email.onChange(user.email);

        if (company) {
          contractor.onChange("" + company.name);
        } else {
          contractor.onChange(user.first_name + " " + user.last_name);
        }
      }

      if (project) {
        name.onChange(project.name);
        project_description.onChange(project.project_description);
        construction_site_id.onChange(project.construction_site_id);
        company_id.onChange(project.company_id);
        site_address.onChange(project.project_site_address);
        postal_area.onChange(project.project_postal_area);
        postal_code.onChange(project.project_postal_code);
        contact_person_name.onChange(project.contact_person_name);
        contact_person_phone.onChange(project.contact_person_phone);
        contact_person_email.onChange(project.contact_person_email);
        active.onChange(project.active);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props$fields2 = this.props.fields,
          user_id = _props$fields2.user_id,
          construction_site_id = _props$fields2.construction_site_id,
          company_id = _props$fields2.company_id,
          business_name = _props$fields2.business_name,
          project_owner_name = _props$fields2.project_owner_name,
          business_email = _props$fields2.business_email,
          name = _props$fields2.name,
          project_description = _props$fields2.project_description,
          phone_number = _props$fields2.phone_number,
          contractor = _props$fields2.contractor,
          site_address = _props$fields2.site_address,
          postal_area = _props$fields2.postal_area,
          postal_code = _props$fields2.postal_code,
          contact_person_name = _props$fields2.contact_person_name,
          contact_person_phone = _props$fields2.contact_person_phone,
          contact_person_email = _props$fields2.contact_person_email,
          active = _props$fields2.active;
      var editing = this.props.editing;


      return _react2.default.createElement(
        "form",
        { id: "createProject", className: "col col-xs-12", onSubmit: this.props.handleSubmit(this.onSubmit) },
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Ty\xF6maatiedot"
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "name", type: "text", label: "Projektin nimi", fieldProps: name })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Textarea2.default, { id: "description", type: "text", label: "Kuvaus", className: "textarea", fieldProps: project_description })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "construction_site_id", type: "text", label: "Ty\xF6numero", fieldProps: construction_site_id })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "contractor", type: "text", label: "Urakoitsija", fieldProps: contractor })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-12" },
            _react2.default.createElement(_Input2.default, {
              id: "site_address",
              type: "text",
              label: "Ty\xF6maan osoite",
              fieldProps: site_address })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "postal_code", type: "text", label: "Postinumero", fieldProps: postal_code })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "postal_area",
              type: "text",
              label: "Paikkakunta",
              fieldProps: postal_area
              /*    handleBlur={(event) => {
                    postal_area.onBlur(event);
                    this.handlePostalAreaChange(event.target.value);
                  }} */
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-12" },
            _react2.default.createElement(_Input2.default, { id: "contact_person_name", type: "text", label: "Yhteyshenkil\xF6", fieldProps: contact_person_name })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "contact_person_phone", type: "text", label: "Puhelinnumero", fieldProps: contact_person_phone })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "contact_person_email", type: "text", label: "S\xE4hk\xF6posti", fieldProps: contact_person_email })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          editing ? _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Checkbox2.default, { id: "active", label: "Aktiivinen Projekti", fieldProps: active })
          ) : ""
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          this.renderSuccessMessage()
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement("div", { className: "col col-sm-6" }),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_SubmitButton2.default, { text: editing ? "Päivitä" : "Julkaise", submitting: this.props.loading })
          )
        ),
        editing ? _react2.default.createElement(
          "div",
          { className: "row" },
          this.showProjektLink()
        ) : ""
      );
    }
  }, {
    key: "showProjektLink",
    value: function showProjektLink() {
      var project = this.props.project;

      if (project) {
        var projectUrl = "/projekti/" + project.project_id;
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: projectUrl },
              "Siirry projekin sivulle"
            ),
            " "
          )
        );
      }
    }
  }, {
    key: "renderSuccessMessage",
    value: function renderSuccessMessage() {
      var _props2 = this.props,
          projects = _props2.projects,
          project = _props2.project;


      if (projects.createProjectSuccess) {
        var projectUrl = "/projekti/" + projects.newProject.id;

        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "success-message success-text-js" },
            "Projektin luonti onnisui! "
          ),
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: projectUrl },
              "Siirry projekin sivulle"
            ),
            " "
          )
        );
      }

      if (project) {
        var _projectUrl = "/projekti/" + project.project_id;
        if (projects.updateProjectSuccess) {
          return _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "p",
              { className: "success-message success-text-js" },
              "Tietojen muokkaus onnistui!"
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: _projectUrl },
                "Palaa projekin sivulle"
              ),
              " "
            )
          );
        }
      } else {
        return null;
      }
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      var _props3 = this.props,
          projects = _props3.projects,
          project = _props3.project;

      if (projects.updateProjectError) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "error-message error-message-js" },
            "Tietojen muuttaminen ep\xE4onnistui. Tarkista antamasi tiedot tai yrit\xE4 my\xF6hemmin uudelleen!"
          )
        );
      }
    }
  }]);
  return ProjectForm;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  submitProject: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object,
  company: _react.PropTypes.object,
  project: _react.PropTypes.object,
  projects: _react.PropTypes.object,
  resetState: _react.PropTypes.func.isRequired
}, _temp2);
exports.default = ProjectForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/projects/ProjectForm.js
 ** module id = 483
 ** module chunks = 0
 **/